import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum'
import { feCommonDataHolder } from '@lastbrand/fe-common'
import { AppProps } from 'next/app'
import Head from 'next/head'
import React, { useEffect } from 'react'

import '@src/globals.css'
import '@src/SectionRenderer/sections/gridSlider/gridSlider.scss'
import '@src/quince-components/src/atoms/swiper/swiper.scss'
import '@src/quince-site-integrated/src/components/FormElements/inputStyles.scss'
import '@src/quince-site-integrated/src/components/FormElements/passwordStyles.scss'
import '@src/pages/contact-us/contact-us-components/glady-help-center/gladly-help-center-external.scss'
import '@src/quince-styles/scss/index.scss' // THIS IS INTENTIONAL DO NOT CHANGE THE ORDER!!!!! THIS SHOULD ALWAYS BE THE LAST IMPORT
import { DD_RUM_APP_ID, DD_RUM_ENABLED_FLAG, DD_RUM_CLIENT_TOKEN } from '@src/config/env'
import { initializeClientEntry } from '@src/modules/client-entry'
import { getIsNativeViewClient } from '@src/quince-site-common/src/helpers/getIsNativeViewClient'
import { useOnRouteUpdate } from '@src/quince-site-common/src/hooks/useOnRouteUpdate'
import { getCookie } from '@src/quince-site-integrated/src/utils'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

const env = process.env.NEXT_PUBLIC_FE_COMMON_ENV ?? 'PROD'
if (DD_RUM_ENABLED_FLAG && DD_RUM_APP_ID && DD_RUM_CLIENT_TOKEN) {
  const datadogConfig: RumInitConfiguration = {
    applicationId: DD_RUM_APP_ID,
    clientToken: DD_RUM_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'ecomm-ssr-rum',
    env: process.env.NEXT_PUBLIC_DD_RUM_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: process.env.NEXT_PUBLIC_RELEASE_VERSION,
    sessionSampleRate: 1,
    sessionReplaySampleRate: 0,
    traceSampleRate: 1,
    telemetrySampleRate: 1,
    defaultPrivacyLevel: 'mask-user-input',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    startSessionReplayRecordingManually: true, // Allow to do session-replay programmatically if needed
    allowedTracingUrls: [
      { match: 'https://api-prod-public.onequince.com/', propagatorTypes: ['tracecontext'] },
      { match: 'https://api-qa.onequince.com/', propagatorTypes: ['tracecontext'] },
    ],
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  datadogRum.init(datadogConfig)
  // console.log('Datadog initialized with configuration', datadogConfig)
}
;(feCommonDataHolder as { initialize: (options: { env: string }) => void }).initialize({ env })
export default function MyApp({ Component, pageProps }: AppProps) {
  useOnRouteUpdate()

  useEffect(() => {
    initializeClientEntry()
    const isNewUserInner = getCookie('new-user-created') === 'random' && getCookie('_lb_user_first_access') === 'true'

    if (isNewUserInner) {
      trackEvent(TELEMETRY_EVENT_NAMES.NEW_USER_CREATED_RANDOM, {})
    }
  }, [])

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content={`width=device-width, initial-scale=1${getIsNativeViewClient() ? ', maximum-scale=1' : ''}`}
        />
      </Head>
      <Component {...pageProps} />
    </>
  )
}
